import Axios from "@/plugins/Axios";
// import store from "@/store";
import Usuario from "@/Models/User";

export class UsuariosService {
  async syncAll() {
    const response = await Axios().get("users");
    const usuarios = response.data.map((usuario) => new Usuario(usuario));
    return usuarios;
  }

  async syncAllPaginate(pageNumber, query = "") {
    const response = await Axios().get(`users/paginate?page=${pageNumber}&query=${query}`);
    // const usuarios = response.data.data.map((usuario) => new Usuario(usuario));
    return response;
  }

  async getUsuario(usuario_id) {
    const response = await Axios().get(`users/${usuario_id}`);
    const usuario = new Usuario(response.data);
    return usuario;
  }

  async criarUsuario(usuario) {
    const response = await Axios().post("users", usuario);
    const novaUsuario = response.data;
    return novaUsuario;
  }

  async atualizarUsuario(usuario) {
    const response = await Axios().put(`users/${usuario.id}`, usuario);
    const usuarioAtualizada = response.data;
    return usuarioAtualizada;
  }

  async deletarUsuario(usuario) {
    const response = await Axios().delete(`users/${usuario.id}`);
    const usuarioDeletada = response.data;
    return usuarioDeletada;
  }

  async recuperarUsuario(usuario) {
    return this.atualizarUsuario({ ...usuario, deleted_at: null });
  }

  async atualizarSituacao(usuario, novaSituacao) {
    const response = await Axios().put(`users/${usuario}/atualizarSituacao`, {
      ...usuario,
      situacao: novaSituacao,
    });
    const aulaAtualizada = response.data;
    return new Usuario(aulaAtualizada);
  }

  async atualizarDataBloqueio(usuario, dataBloqueio) {
    const response = await Axios().put(`users/${usuario}/atualizar-data-bloqueio`, {
      ...usuario,
      data_bloqueio: dataBloqueio || null,
    });
    const aulaAtualizada = { ...response.data, data_bloqueio: dataBloqueio };
    return new Usuario(aulaAtualizada);
  }

  async coordenadoresResponsaveisList(franquia_id) {
    const response = await Axios().get(`users/coordenadores-responsaveis/${franquia_id}`);
    const usuarios = response.data.map((usuario) => new Usuario(usuario));
    return usuarios;
  }
}
export default new UsuariosService();
